import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Supplier, supplierType } from '../../types/slices/supplierType'

const initialState: supplierType =
{
    status: ApiStatus.FETCHED,
    supppliers: [],
    supplierSelected: {} as Supplier,
    errorMessage: undefined,
    action: ''
}

const supplierSlice = createSlice({
    name: 'supplierSlice',
    initialState,
    reducers: {
        onFetchSuppliers (state, { payload }: { payload: Supplier[]}) {
        state.status = ApiStatus.FETCHED
        state.supppliers = payload
        state.errorMessage = undefined
        },
        onSetSelectedSupplier (state, { payload }: { payload: Supplier }) {
        state.supplierSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectSupplierState = (state: RootState) => state.supplierSlice
export default supplierSlice.reducer
export const {
    onFetchSuppliers,
    onSetSelectedSupplier,
    changeStatus,
    setAction,
} = supplierSlice.actions
